export default {
  delayInput: {
    width: 120,
  },
};
